import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const PersistentLogin = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  let token;
  let registrationDesk;

  useEffect(() => {
    token = localStorage.getItem("token");
    registrationDesk = localStorage.getItem("registrationDesk");

    if (!token && !registrationDesk) {
      setIsLoading(true);
      setAuth(null);
      navigate("/login", { state: location, replace: true });
    } else {
      setAuth({ token, registrationDesk });
      setIsLoading(false);
    }
  }, []);

  return <>{isLoading ? <p>Loading...</p> : <Outlet />}</>;
};
